module.exports = __webpack_public_path__ + "img/package-appropriate.297941ad.png";